import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';
import __t from '../../locales';
import { TreeTable, TreeState } from 'cp-react-tree-table';
import { Switch } from '@material-ui/core';

export const EmissionProfileSwitchTable = forwardRef((props, ref) => {
    console.log(props);
    const [treeValue, setTreeValue] = useState(TreeState.createEmpty());

    useEffect(() => {
        const treeData = props.allEmissionProfiles.map(p => {
            return {
                data: {
                    id: p,
                    value: p,
                    checked: Boolean(props.emissionProfiles.find(ep => ep === p))
                }
            };
        });

        setTreeValue(TreeState.create(treeData));
    }, [props.allEmissionProfiles, props.emissionProfiles]);

    useImperativeHandle(ref, () => ({
        getValues: () => {
            if (treeValue.hasData) {
                return treeValue.data.filter(p => p.data.checked).map(c => c.data.value);
            }
            return [];
        }
    }));

    return (
        <>
            <TreeTable
                value={treeValue}
                onChange={(newState) => setTreeValue(newState)}
                height={300}
            >
                <TreeTable.Column
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center"
                            }}>
                                <span>{row.data.value}</span>
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span>{__t('emission_profile')}</span>}
                />
                <TreeTable.Column
                    renderCell={(row) => {
                        return (
                            <div style={{
                                height: "100%",
                                display: "flex",
                                flexDirection: "row-reverse",
                                alignItems: "center"
                            }}>
                                <Switch
                                    checked={row.data.checked}
                                    onChange={() => {
                                        row.updateData({ ...row.data, checked: !row.data.checked });
                                    }}
                                />
                            </div>
                        )
                    }}
                    renderHeaderCell={() => <span></span>}
                />
            </TreeTable>
        </>
    );
});

EmissionProfileSwitchTable.propTypes = {
    allEmissionProfiles: PropTypes.array,
    emissionProfiles: PropTypes.array,
}